import { render, staticRenderFns } from "./prompt-list-groups.vue?vue&type=template&id=3eecf6ba&"
import script from "./prompt-list-groups.vue?vue&type=script&lang=js&"
export * from "./prompt-list-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports